import Loader from "../../Loader/buttonLoad";
import { useGetCmsdata } from "./Privacyapi";

const Privacy = (props) => {   
     const language = localStorage.getItem('Lang') || 'english'
       const { data: Cmsdata, isLoading } = useGetCmsdata({
                       
        fieldtype: "privacypolicy",
        language:language
            });
        
    return (            
        <div className="MainBg">
            <div className="CntLdDv">
                <div className="PrcyPlyPg">
                    <div className="container">
                        {isLoading ? <Loader/> : 
                        <div className="PrcyPlyBg" dangerouslySetInnerHTML={{__html:Cmsdata?.data?.content}}>

                           </div>
}
                    </div>
                </div>
            </div>
        </div>
    );
   
}

export default Privacy;